import axios from "../../../axios";

import React, { useState } from "react";
import "./queryList.css";
import assets from "../../../assets/assets";

const ResolveQuery = ({ setQuery, queryId, setMarkQuery, setExpandQuery, setDataFinal, getQueryNew, queries }) => {
  let studentData = JSON.parse(localStorage.getItem("breathForStudent"));
  const [isInProgress, setIsInProgress] = useState(false);
  const handleMarkQuery = async () => {
    setIsInProgress(true);
    try {
      let res = await axios.put(`/query/updateStatus/${queryId}`, {
        user_id: studentData?.id,
        updatedStatus: "resolved",
      });
      res && getQueryNew()
      //   setQuery((prevQuery) => {
      //     return prevQuery.map((query) => {
      //       if (query.id === queryId) {
      //         return { ...query, status: "resolved" };
      //       } else {
      //         return query;
      //       }
      //     });
      //   });

      // setExpandQuery(false);
      // setDataFinal({});

    } catch (error) {
      setIsInProgress(false);
      console.log(error);
    } finally {
      setMarkQuery(false);
      setIsInProgress(false);
    }
  };
  return (
    <div className=" delete_query_transprant_body">
      <div className=" p-3 d-flex align-items-center justify-content-center flex-column delete_query_container shadow relative">
        <img
          src={assets.CrossIcon}
          className="absolute top-1 right-1 w-7"
          alt="icon"
          onClick={(e) => setMarkQuery(false)}
        />
        <div className=" col-12 d-flex align-items-center justify-content-center flex-column text-center">
          <span className="mt-4 mb-5 delete_query_text">
            Are you sure you want to resolve this query?
          </span>
          <div className="col-12 p-0 gap-3 flex-wrap d-flex justify-content-center ">
            <button
              disabled={isInProgress}
              className="btn btn-danger col-sm-5 query_delete_btn"
              onClick={handleMarkQuery}
            >
              Yes
            </button>
            <button
              disabled={isInProgress}
              className="btn btn-danger col-sm-5 query_delete_btn default_deleteq_uery_no"
              onClick={(e) => setMarkQuery(false)}
            >
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResolveQuery;
